import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";

const code = tv({
  base: "block rounded-md bg-background p-2 font-mono text-text-primary",
  variants: {
    variant: {
      "2fa": "break-all whitespace-pre-line",
      default: "wrap-break-word whitespace-pre-wrap",
    },
    size: {
      sm: "text-xs",
      md: "text-sm",
      lg: "text-base",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "md",
  },
});

export default function Code({
  children,
  variant,
  size,
}: { readonly children: React.ReactNode } & VariantProps<typeof code>) {
  return <code className={code({ variant, size })}>{children}</code>;
}
